import React from 'react';
// import { NavLink } from 'react-router-dom';
import { Title } from "./Title";
import { PortfolioCard } from './PortfolioCard';
import PortfolioImg from '../Img/portfolio image.png';
import cardImg1 from '../Img/Screenshot (3).png';
import cardImg2 from '../Img/Screenshot (2).png';
import cardImg3 from '../Img/Screenshot (6).png';
import cardImg4 from '../Img/pokedex.png';
import cardImg5 from '../Img/weather_app.png';
import cardImg6 from '../Img/driversinIndia.png';
import cardImg7 from '../Img/yelp_Camp.png';
import cardImg8 from '../Img/notesApp.png';
import cardImg9 from '../Img/Ip_address_tracker.png';
import cardImg10 from '../Img/Space_tourism.png';
import cardImg11 from '../Img/multiStepsForm.png';
import cardImg12 from '../Img/Mobile_Banner_IPRU_EDGE_cropped.jpg';
import cardImg13 from '../Img/IPRU_logo.png';
import cardImg14 from '../Img/Promptopia.png';
import cardImg15 from '../Img/keep-Notes.png';

export const Portfolio = () => {
    return (
        <>
            <div className="container" id="Portfolio">
                <div className="row">
                    <div data-aos="fade-right" className="col-1">
                        <h1>Portfolio</h1>
                        <h4>Checkout some of my UIUX design & website.</h4>
                        <p>All of these work are done by me from scratch or using some framework, most of these are uploaded on github or other platforms.</p>
                        <a href="https://github.com/Aveshkhan" className="custom-btn btn-17 d-flex-center" rel="noreferrer" target="_blank"><box-icon name='github' type='logo' color='var(--font-color)' ></box-icon> &nbsp; See GitHub </a>
                    </div>
                    <div data-aos="fade-left" className="col-1">
                        <img src={PortfolioImg} alt="" />
                    </div>
                </div>

                <Title
                    title="SOME OF MY WORK"
                />

                <div className="works">
                    <div className="row">
                        <PortfolioCard
                            cardImg={cardImg15}
                            cardTitle="Keep Notes"
                            cardSpecify="Notes Taking App build on MERN stack, OAuth2.0 and PrimeReact. with Dark and Light modes"
                            url="https://keep-notes-ashy-chi.vercel.app/"
                            skill_1="react"
                            skill_2="nodejs"
                            skill_3="mongodb"
                        />
                        <PortfolioCard
                            cardImg={cardImg14}
                            cardTitle="Promptopia"
                            cardSpecify="Promptopia is an open-source AI prompting tool for modern world to discover, create and share creative prompts"
                            url="https://promptopia-alpha-nine.vercel.app/"
                            skill_1="react"
                            skill_2="nodejs"
                            skill_3="mongodb"
                        />
                        <PortfolioCard
                            cardImg={cardImg13}
                            cardTitle="ICICI Prudential Life Insurance"
                            cardSpecify="UI design & developed IPRU modules like Spaarc, Affinity, Partners, etc."
                            url="https://www.iciciprulife.com/"
                            skill_1="figma"
                            skill_2="javascript"
                            skill_3="bootstrap"
                        />
                        <PortfolioCard
                            cardImg={cardImg12}
                            cardTitle="IPRU EDGE"
                            cardSpecify="Designed modern & interactive UI/UX for ICICI Prudential Advisors"
                            url="https://www.figma.com/file/cRvCeHIQP5S74gVTaV19NO/advisor-app?type=design&node-id=0%3A1&mode=design&t=OoXMhDuiEo5R9fSM-1"
                            skill_1="figma"
                        />
                        <PortfolioCard
                            cardImg={cardImg11}
                            cardTitle="Multi Steps Form"
                            cardSpecify="Multiple steps subscription form challenge by frontendmentor.io"
                            url="https://multi-steps-form-zeta.vercel.app/"
                            skill_1="react"
                            skill_2="javascript"
                            skill_3="bootstrap"
                        />
                        <PortfolioCard
                            cardImg={cardImg10}
                            cardTitle="Space Tourism"
                            cardSpecify="Responsive Space Tour website design challenge by frontendmentor.io"
                            url="https://space-tourism-aveshkhan.vercel.app/"
                            skill_1="react"
                            skill_2="javascript"
                            skill_3="tailwind-css"
                        />
                        <PortfolioCard
                            cardImg={cardImg9}
                            cardTitle="Ip-address-tracker"
                            cardSpecify="Public IP address tracker created with ipgeo api & react-leaflet"
                            url="https://reactjs-ip-address-tracker.vercel.app/"
                            skill_1="react"
                            skill_2="javascript"
                            skill_3="bootstrap"
                        />
                        <PortfolioCard
                            cardImg={cardImg4}
                            cardTitle="Pokédex"
                            cardSpecify="Pokedex created by consuming pokeapi.co"
                            url="https://pokedex-aveshkhan.vercel.app/"
                            skill_1="angular"
                            skill_2="typescript"
                            skill_3="bootstrap"
                        />
                        <PortfolioCard
                            cardImg={cardImg5}
                            cardTitle="Weather App"
                            cardSpecify="It shows weather of current location and can serach other locations"
                            url="https://weather-app-aveshkhan.vercel.app/"
                            skill_1="angular"
                            skill_2="typescript"
                            skill_3="bootstrap"
                        />
                        <PortfolioCard
                            cardImg={cardImg6}
                            cardTitle="Drivers in India"
                            cardSpecify="Worked on development&functionality of CRM, Customer Portal, Drivers App"
                            url="https://driversinindia.com/"
                            skill_1="angular"
                            skill_2="nodejs"
                            skill_3="postgresql"
                        />
                        <PortfolioCard
                            cardImg={cardImg7}
                            cardTitle="Yelp Camps"
                            cardSpecify="A Static web design of Yelp Camps by using react.js"
                            url="https://yelpcamps.netlify.app/"
                            skill_1="react"
                            skill_2="javascript"
                            skill_3="sass"
                        />
                        <PortfolioCard
                            cardImg={cardImg8}
                            cardTitle="Notes App"
                            cardSpecify="A simple notes taking website which save notes on local storage"
                            url="https://aveshkhan.github.io/NotesApp/"
                            skill_1="javascript"
                            skill_2="bootstrap"
                        />
                        <PortfolioCard
                            cardImg={cardImg1}
                            cardTitle="Aafiya Mediretreats"
                            cardSpecify="A Hospital website, I've made it for an internship."
                            url="https://aveshkhan.github.io/Aafiya-Mediretreats/"
                            skill_1="javascript"
                            skill_2="bootstrap"
                        />
                        <PortfolioCard
                            cardImg={cardImg2}
                            cardTitle="Red Store"
                            cardSpecify="An E-commerce webite design for sports wear."
                            url="https://aveshkhan.github.io/RedStore"
                            skill_1="javascript"
                        />
                        <PortfolioCard
                            cardImg={cardImg3}
                            cardTitle="iCoderBootstrap"
                            cardSpecify="Blog website for developer using latest Bootstrap5."
                            url="https://aveshkhan.github.io/iCoderBootstrap/"
                            skill_1="javascript"
                            skill_2="bootstrap"
                        />

                    </div>
                </div>
            </div>
        </>

    )
}